import { GenericLookupType } from 'src/core/decorators/generic-lookup/generic-lookup-type.decorator';
import { GenericLookup } from 'src/core/decorators/generic-lookup/generic-lookup.decorator';

@GenericLookupType({
  code: 'Email.Direction',
})
export class EmailDirection {
  @GenericLookup({
    code: 'Email.Direction.Unknown',
  })
  static unknown: number;

  @GenericLookup({
    code: 'Email.Direction.Sent',
  })
  static sent: number;

  @GenericLookup({
    code: 'Email.Direction.Received',
  })
  static received: number;
}
